import memoize from 'lodash/memoize';

import get from 'lodash/get';
import hashify from 'object-hash';

import { ArticleUserStory } from 'types';

export default memoize((articleUserStorys: unknown): ArticleUserStory[] => {
  if (!Array.isArray(articleUserStorys)) {
    return [];
  }

  return articleUserStorys
    .filter((articleUserStory) => !!get(articleUserStory, 'approved', false))
    .map((articleUserStory: unknown) => {
      return {
        id: hashify(
          `${get(articleUserStory, 'submitted', '')} - ${get(
            articleUserStory,
            'story',
            ''
          )}`
        ),
        story: get(articleUserStory, 'story', ''),
        name: get(articleUserStory, 'name', ''),
        title: get(articleUserStory, 'title', ''),
        date: get(articleUserStory, 'submitted', '').split(' ')[0],
        likes: get(articleUserStory, 'likes', 0),
      };
    })
    .sort((a, b) => (new Date(b.date) as any) - (new Date(a.date) as any));
});
